import * as z from "zod";

export const DOMAIN_MAX_LENGTH = 64;

export const countsTowardDomainLimit = (setup: {
  hostname: string;
  managed: boolean | null;
}) => setup.managed || !/\.3b\.(run|dev)$/.test(setup.hostname);

export const CUSTOM_DOMAIN_SETUP_EXPIRY_MS = 7 * 24 * 60 * 60_000;

export const CUSTOM_DOMAIN_STATUSES = [
  "pending",
  "dns",
  "tls",
  "ready",
  "removing",
  "error",
  "expired",
] as const;

export type CustomDomainDnsRecord = {
  type: "CNAME" | "TXT";
  name: string;
  value: string;
  purpose: "routing" | "ownership" | "certificate";
  verified: boolean;
};

type ProvisioningDomain = {
  id: string;
  hostname: string;
  status: (typeof CUSTOM_DOMAIN_STATUSES)[number];
  dnsRecords: CustomDomainDnsRecord[];
  ownershipToken: string | null;
  activatedAt?: number | null;
};
export type ProvisioningRequest = ProvisioningDomain & {
  tenantId: string;
  domains: ProvisioningDomain[];
  originNames: string[];
  certificateRequestId: string | null;
  remove?: boolean;
};
export type ProvisioningResult = {
  requestId: string | null;
  records: CustomDomainDnsRecord[];
  status: "pending" | "tls" | "ready" | "error";
  error: string | null;
  dnsVerified?: boolean;
  invalidDomains?: string[];
};

export const customDomainSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z](?:[a-z0-9-]{0,61}[a-z0-9])?$/,
    "Enter a domain such as workflows.example.com, without https://, a path, or a wildcard."
  );

export function customDomainHostname(domain: string, spaceId?: string | null) {
  return spaceId ? domain : `*.${domain}`;
}
